// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1gpjy","title":"InfoRow_title__3enmO"};